export const fetchIssueTypesData = () => {
    return {
        type: 'FETCH_ISSUE_TYPES_DATA'
    }
}